// Obsidian — Deep carbon base, electric sapphire accent
// Premium SaaS / fintech feel — sharp, confident, modern

export const darkColors = {
  background:       '#07090F',                    // deepest layer — near-black with cold blue cast
  surface:          '#0C1020',                    // cards, modals, sheets
  surfaceElevated:  '#121728',                    // inputs, nested cards
  surfaceHighlight: '#192033',                    // hover / active / pressed states
  accent:           '#4F7EF8',                    // electric sapphire — not basic blue
  accentLight:      'rgba(79,126,248,0.12)',
  accentDark:       '#3A68E8',
  success:          '#22C55E',                    // vivid emerald green
  successLight:     'rgba(34,197,94,0.12)',
  warning:          '#F59E0B',
  warningLight:     'rgba(245,158,11,0.12)',
  danger:           '#F43F5E',                    // rose-red — more refined than flat red
  dangerLight:      'rgba(244,63,94,0.12)',
  text:             '#E6ECFF',                    // blue-tinted white — easier on the eyes
  textSecondary:    'rgba(230,236,255,0.55)',
  textMuted:        'rgba(230,236,255,0.28)',
  border:           'rgba(79,126,248,0.09)',       // barely-there blue-tinted border
  borderFocus:      'rgba(79,126,248,0.50)',
  overlay:          'rgba(0,0,0,0.72)',
  isDark:           true,
};

export const lightColors = {
  background:       '#EFF3FF',                    // subtle blue-white — never clinical white
  surface:          '#F8FAFF',                    // near-white with blue cast
  surfaceElevated:  '#E5ECFF',                    // clearly distinct from surface
  surfaceHighlight: '#D8E3FF',                    // pressed / active states
  accent:           '#3A68E8',                    // deep sapphire
  accentLight:      'rgba(58,104,232,0.10)',
  accentDark:       '#2B57D4',
  success:          '#16A34A',
  successLight:     'rgba(22,163,74,0.10)',
  warning:          '#D97706',
  warningLight:     'rgba(217,119,6,0.10)',
  danger:           '#E11D48',
  dangerLight:      'rgba(225,29,72,0.10)',
  text:             '#08102A',                    // deep navy-black
  textSecondary:    'rgba(8,16,42,0.55)',
  textMuted:        'rgba(8,16,42,0.30)',
  border:           'rgba(8,16,42,0.08)',
  borderFocus:      'rgba(58,104,232,0.45)',
  overlay:          'rgba(0,0,0,0.50)',
  isDark:           false,
};

export const spacing = {
  xs:    4,
  sm:    8,
  md:    12,
  base:  16,
  lg:    20,
  xl:    24,
  xxl:   32,
  xxxl:  48,
};

export const radius = {
  sm:   10,
  md:   16,
  lg:   22,
  xl:   32,
  full: 9999,
};

export const typography = {
  sizes: {
    xs:   11,
    sm:   13,
    base: 15,
    md:   17,
    lg:   20,
    xl:   24,
    xxl:  30,
    xxxl: 38,
  },
  weights: {
    regular:   '400',
    medium:    '500',
    semibold:  '600',
    bold:      '700',
    extrabold: '800',
  },
  lineHeights: {
    tight:   1.2,
    normal:  1.5,
    relaxed: 1.7,
  },
  letterSpacing: {
    tight:  -0.5,
    normal:  0,
    wide:    0.5,
    wider:   1,
  },
};

export const shadows = {
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.28,
    shadowRadius: 6,
    elevation: 4,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.35,
    shadowRadius: 14,
    elevation: 10,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 14 },
    shadowOpacity: 0.45,
    shadowRadius: 28,
    elevation: 20,
  },
  accent: (isDark) => ({
    shadowColor: isDark ? '#4F7EF8' : '#3A68E8',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: isDark ? 0.40 : 0.28,
    shadowRadius: 18,
    elevation: 12,
  }),
};

// Backwards-compatible default export
const theme = {
  colors: darkColors,
  spacing,
  radius,
  typography,
  shadows,
};

export default theme;
